// extracted by mini-css-extract-plugin
export default {"cardLegend":"OverviewCardLegend_cardLegend__xksBo","legendItem":"OverviewCardLegend_legendItem__Al8kC","wrapped":"OverviewCardLegend_wrapped__QpTpM"};